import { Col, H4, H5, IconLockup, Markdown, PortableText, Row, SpacerWrapper } from '@ahmdigital/ui';
import { isEmpty, map } from 'lodash/fp';
import React from 'react';

import { Item } from '../../../types';
import FeatureHighlight from './feature-highlight';
import styles from './styles.module.sass';

export type ItemsSectionProps = {
  isPortableTextDescription?: boolean;
  items: Item[];
  type: string;
};

const TYPE_PROPS = {
  addons: { icon: 'plus', title: 'Add ons', type: 'partial' },
  benefits: { icon: 'tick', title: 'Additional benefits', type: 'included' },
  inclusions: { icon: 'tick', title: 'What’s included', type: 'included' },
  sellingPoints: { icon: 'tick', type: 'included' },
};

// @ts-expect-error - Automatic, Please fix when editing this file
const getDescriptionComponent = ({ description, isPortableTextDescription }) =>
  isPortableTextDescription ? <PortableText source={description} /> : <Markdown>{description}</Markdown>;

const ItemsSection = ({ isPortableTextDescription, items, type }: ItemsSectionProps) => {
  if (isEmpty(items)) {
    return null;
  }
  // @ts-expect-error - Automatic, Please fix when editing this file
  const { title, icon, type: iconType } = TYPE_PROPS[type] || {};
  const hasSectionTitle = !isEmpty(title);
  // Render the correct a11y heading for the itemTitle (don't skip heading level)
  const ItemTitleHeading = hasSectionTitle ? H5 : H4;
  return (
    <SpacerWrapper variant="marginTopSpacer7">
      {hasSectionTitle && <H4>{title}</H4>}
      <Row>
        {map(
          ({ callout, description, title: itemTitle }) => (
            <Col key={itemTitle} df={4} sm={6} xs={12} variant="marginTopSpacer10">
              {/* @ts-expect-error [🤖 PLEASE FIX 🤖]: Type '{ className: string | undefined; name: string; size: string; type: any; }' is not assignable to type '({ name, size, ...restOfProps }: { name: "document" | "history" | "time" | "search" | "list" | "phone-circle" | "ambulance-services" | "ambulance" | "app-chevron-down" | "app-chevron-left" | "app-chevron-right" | ... 93 more ... | "youtube"; size?: "small" | ... 4 more ... | undefined; } & ComponentProps) => React.J...'. */}
              <IconLockup icon={{ className: styles.icon, name: `${icon}-circle`, size: 'small', type: iconType }}>
                <ItemTitleHeading looksLike="h5">
                  {itemTitle}
                  {callout && [' ', <FeatureHighlight key={callout} text={callout} />]}
                </ItemTitleHeading>
                {description && getDescriptionComponent({ description, isPortableTextDescription })}
              </IconLockup>
            </Col>
          ),
          items,
        )}
      </Row>
    </SpacerWrapper>
  );
};

export default ItemsSection;
